import { type ReactNode } from 'react';
import { modalRenderer } from '~/modal/modalRendererRegistry';
import { MigrateMapsConfirmationComponent } from './migrateMapsConfirmation.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrationConfirmation: {
      onConfirm: () => void;
      warningText: ReactNode;
      requiresConfirmation?: boolean;
    };
  }
}

modalRenderer.register('MigrationConfirmation', (props) => <MigrateMapsConfirmationComponent {...props} />);
